import React from "react";
import ModalSkeleton from "../../components/ModalSkeleton";
import { LogoutIcon } from "../../constant";
import classes from "./ForgotPasword.module.css";
import ModalAction from "../../components/ModalAction";
import { logout, setPassword } from "../../store/authSlice";
import { Input } from "../../components/Input";
import { emailSchema } from "../../schema";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import useApi from "../../useApi";
const initialValues = {
  email: "",
};
const ForgotPasswordModal = ({ show, setShow, loading, onSubmit }) => {
  const formik = useFormik({
    initialValues,
    validationSchema: emailSchema,
    onSubmit: (values) => {
      if (typeof onSubmit === "function")
        onSubmit({ ...values, companyDetailID: 1 });
    },
  });
  const {
    touched,
    errors,
    values,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
    resetForm,
  } = formik;
  const handleChangeWithTouch = (field) => (value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };

  return (
    <>
      <ModalSkeleton
        title={"Forgot Password"}
        width="500px"
        show={show}
        setShow={setShow}
      >
        <form onSubmit={handleSubmit} className={classes.wrapper}>
          <Input
            type="email"
            placeholder="Enter Email"
            label={"email"}
            value={values?.email}
            onChange={handleChangeWithTouch("email")}
            errorText={touched?.email && errors?.email}
          />
          <ModalAction
            isApiCall={loading}
            className={classes.bottomCtas}
            onConfirm={logout}
            onCancel={resetForm}
          />
        </form>
      </ModalSkeleton>
    </>
  );
};

export default ForgotPasswordModal;
